var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pop',{attrs:{"titledata":_vm.datainfo.panelName,"styledata":_vm.datainfo.styledata}},[_c(_vm.datainfo.componentname,{tag:"component",attrs:{"datainfo":_vm.datainfo}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6fcaaf0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webgl/ui/pop/datapop.vue
// module id = null
// module chunks = 